import { useContext } from 'react'
import { InputsContext } from '../../InputsContext'

const isValidPostalCode = (code) => /^\d{4}$/.test(code);

export const useHandleCalculate = ({ priceEngineProxyUrl, labels }) => {
    const {
        setErrorInputPostalCodeFrom,
        setErrorInputPostalCodeTo,
        setZoneCount,
        setLoading,
        loading,
        setError,
        serviceType,
        sendFrom,
        sendTo
    } = useContext(InputsContext)

    const handleCalculate = async () => {

        setErrorInputPostalCodeFrom(null)
        setErrorInputPostalCodeTo(null)

        let hasError = false

        // Validate sendFrom
        if (!sendFrom || sendFrom.trim() === "") {
            setErrorInputPostalCodeFrom(labels.postalErrorMessage);
            hasError = true;
        } else if (!isValidPostalCode(sendFrom)) {
            setErrorInputPostalCodeFrom(labels.postalErrorMessage);
            hasError = true;
        }

        // Validate sendTo
        if (!sendTo || sendTo.trim() === "") {
            setErrorInputPostalCodeTo(labels.postalErrorMessage);
            hasError = true;
        } else if (!isValidPostalCode(sendTo)) {
            setErrorInputPostalCodeTo(labels.postalErrorMessage);
            hasError = true;
        }


        if (hasError) {
            return
        }

        setError(null)
        setLoading(true)
        setZoneCount(null)

    // the dimension input is hardcoded. We need to pass something to the api to fetch the zone
    try {
        const payload = {
            service: serviceType,
            fromPostalCode: sendFrom,
            toPostalCode: sendTo,
            consignmentItems: [
                {
                    weight: 1000,
                    length: 25,
                    width: 25,
                    height: 25
                }
            ]
        }

        const response = await fetch(
            priceEngineProxyUrl,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            }
        )

        const data = await response.json();

        const product = data?.consignments?.[0]?.products?.[0]
        if (product?.errors?.some(e => e.errorCode === "OUTSIDE_COVERAGE_AREA") || product?.errors?.some(e => e.errorCode === "OUTSIDE_COVERAGE_AREA_TO_PO_BOX")) {
            setError(labels.errorOutsideCoverageArea)
        } else if (product?.price?.zones?.totalZoneCount) {
            setZoneCount(product.price.zones.totalZoneCount)
        } else {
            setError(labels.errorNoZone)
        }

    } catch (err) {
        setError(labels.errorFetching)
    } finally {
        setLoading(false)
    }
    }
  return {
    handleCalculate,
    loading
  }
}
